import { AxiosError } from 'axios';

import api from '../../../api';

import type { QueryFunction } from '@tanstack/react-query';
import type { IncentiveCampaignOptinResultType } from 'domains/loyalty.d';

export const getIncentiveCampaignOptin: QueryFunction<IncentiveCampaignOptinResultType> = async ({
  queryKey: [campaignId],
}) => {
  try {
    if (!campaignId) {
      return { campaign: null, isResaleIntention: false, notFound: false };
    }
    const response = await api.get(`/loyalty/incentive-campaign/${campaignId as string}`);
    return { campaign: response.data, isResaleIntention: false, notFound: false };
  } catch (error) {
    const typedError = error as AxiosError;
    const statusCode = typedError.response?.status || typedError.status;
    if (statusCode === 403) {
      return { campaign: null, isResaleIntention: true, notFound: false };
    }

    if (statusCode === 404) {
      return { campaign: null, isResaleIntention: false, notFound: true };
    }

    throw error;
  }
};
